module.exports = __webpack_public_path__ + "static/car4-f952831aa9e3bb4dc92d7ca48ee8bd3f.png";